import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { Icon } from "./icons.js";
import { colors } from "./theme.js";
/**
 * Consistent "← Back to X" link used at the top of detail pages. Single source
 * of truth so every detail page's back affordance looks and behaves the same.
 */
export function BackLink({ to, label }) {
    return (_jsx("div", { style: { marginBottom: 8 }, children: _jsxs(Link, { to: to, style: {
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
                color: colors.textSecondary,
                textDecoration: "none",
                fontSize: "0.85rem",
            }, children: [_jsx(Icon, { name: "chevron-left", size: 14 }), " ", label] }) }));
}
